import {
  ANOTHER_PRODUCT,
  ADDRESS_ROUTE,
  AUTHORIZE_THIRD,
  ARRIVED_INCOMPLETE,
  BAD_STATE,
  BENEFITS_ROUTE,
  CHANGE_DISPATCH_ADDRESS,
  CHANGE_DISPATCH_DATE,
  CONTACT_US_ROUTE,
  DATA_ROUTE,
  EXCHANGE_DETAIL_ROUTE,
  EXCHANGE_ROUTE,
  GIFTCARD_BALANCE_ROUTE,
  MENU_ROUTE,
  NOT_WORKING,
  PRODUCT_CHANGE,
  MY_CLUBS_ROUTE,
  PASSWORD_ROUTE,
  PAY_CARD,
  POINTS_ROUTE,
  PRODUCT_DETAIL_MOBILE_ROUTE,
  PRODUCT_DETAIL_TRACKING_MOBILE_ROUTE,
  PURCHASE_ROUTE,
  REPORT_ISSUES,
  REPORT_PAGE_ERROR,
  REPORT_PURCHASE_ERROR,
  REQUEST_BILL_IMAGE,
  REQUEST_BLOCK_CARD,
  REQUEST_CHANGE_RIPLEYCARD,
  REQUEST_EXTEND_GIFT_CARD,
  REQUEST_EXTEND_GIFT_CARD_COMPANY,
  REQUEST_INSURANCES_INFORMATION,
  REQUEST_NOT_PRODUCT_TICKET,
  REQUEST_RPGO_INFORMATION,
  REQUEST_PAY_ACCOUNT,
  SILVER_GOLD_PAYMENT,
  TICKETS_ROUTE,
  TICKET_DETAIL_MOBILE_ROUTE,
  CANCEL_PURCHASE,
  CANCELLATION_PURCHASE_STATUS,
  ASSEMBLE_PRODUCT,
  ALARM_IN_PRODUCT,
  REPORT_GIFTCARD_PROBLEM,
  GENERAL_CLUBS_PROBLEMS,
  NOT_RECEIVED,
} from './Routes';

const menuBasePath = {
  prevRoute: MENU_ROUTE,
  titlePrevRoute: 'menú',
};

const reportIssuePath = {
  titlePrevRoute: 'reportar inconveniente',
};

const reportIssueNoProductPath = {
  titlePrevRoute: 'realizar solicitud',
};

export const routerTreeMap = new Map();

routerTreeMap.set(DATA_ROUTE, menuBasePath);

routerTreeMap.set(PURCHASE_ROUTE, menuBasePath);

routerTreeMap.set(PASSWORD_ROUTE, menuBasePath);

routerTreeMap.set(ADDRESS_ROUTE, menuBasePath);

routerTreeMap.set(TICKETS_ROUTE, menuBasePath);

routerTreeMap.set(GIFTCARD_BALANCE_ROUTE, menuBasePath);

routerTreeMap.set(MY_CLUBS_ROUTE, menuBasePath);

routerTreeMap.set(POINTS_ROUTE, menuBasePath);

routerTreeMap.set(BENEFITS_ROUTE, menuBasePath);

routerTreeMap.set(EXCHANGE_ROUTE, menuBasePath);

routerTreeMap.set(REQUEST_NOT_PRODUCT_TICKET, menuBasePath);

routerTreeMap.set(CONTACT_US_ROUTE, menuBasePath);

routerTreeMap.set(PAY_CARD, menuBasePath);

routerTreeMap.set(EXCHANGE_DETAIL_ROUTE, {
  prevRoute: EXCHANGE_ROUTE,
  titlePrevRoute: 'canjes realizados',
});

routerTreeMap.set(PRODUCT_DETAIL_MOBILE_ROUTE, {
  prevRoute: PURCHASE_ROUTE,
  titlePrevRoute: 'compras realizadas',
});

routerTreeMap.set(PRODUCT_DETAIL_TRACKING_MOBILE_ROUTE, {
  titlePrevRoute: 'detalle de la compra',
});

routerTreeMap.set(REPORT_ISSUES, {
  titlePrevRoute: 'detalle de la compra',
});

routerTreeMap.set(NOT_RECEIVED, reportIssuePath);

routerTreeMap.set(AUTHORIZE_THIRD, reportIssuePath);

routerTreeMap.set(CHANGE_DISPATCH_ADDRESS, reportIssuePath);

routerTreeMap.set(CHANGE_DISPATCH_DATE, reportIssuePath);

routerTreeMap.set(SILVER_GOLD_PAYMENT, reportIssuePath);

routerTreeMap.set(BAD_STATE, reportIssuePath);

routerTreeMap.set(ARRIVED_INCOMPLETE, reportIssuePath);

routerTreeMap.set(NOT_WORKING, reportIssuePath);

routerTreeMap.set(PRODUCT_CHANGE, reportIssuePath);

routerTreeMap.set(ANOTHER_PRODUCT, reportIssuePath);

routerTreeMap.set(TICKET_DETAIL_MOBILE_ROUTE, {
  prevRoute: TICKETS_ROUTE,
  titlePrevRoute: 'solicitudes realizadas',
});

routerTreeMap.set(REQUEST_BLOCK_CARD, reportIssueNoProductPath);

routerTreeMap.set(REQUEST_CHANGE_RIPLEYCARD, reportIssueNoProductPath);

routerTreeMap.set(REQUEST_PAY_ACCOUNT, reportIssueNoProductPath);

routerTreeMap.set(REQUEST_RPGO_INFORMATION, reportIssueNoProductPath);

routerTreeMap.set(REQUEST_INSURANCES_INFORMATION, reportIssueNoProductPath);

routerTreeMap.set(REQUEST_BILL_IMAGE, reportIssueNoProductPath);

routerTreeMap.set(REPORT_PAGE_ERROR, reportIssueNoProductPath);

routerTreeMap.set(REPORT_PURCHASE_ERROR, reportIssueNoProductPath);

routerTreeMap.set(REQUEST_EXTEND_GIFT_CARD, reportIssueNoProductPath);

routerTreeMap.set(REQUEST_EXTEND_GIFT_CARD_COMPANY, reportIssueNoProductPath);

routerTreeMap.set(REPORT_GIFTCARD_PROBLEM, reportIssueNoProductPath);

routerTreeMap.set(GENERAL_CLUBS_PROBLEMS, reportIssueNoProductPath);

routerTreeMap.set(CANCEL_PURCHASE, reportIssuePath);

routerTreeMap.set(CANCELLATION_PURCHASE_STATUS, reportIssuePath);

routerTreeMap.set(ASSEMBLE_PRODUCT, reportIssuePath);

routerTreeMap.set(ALARM_IN_PRODUCT, reportIssuePath);
